export enum UpdateType {
  StatusChange = 1,
  ProgressNote = 2,
  SystemEvent = 3,
  OfferAccepted = 4,
  ProviderConfirmed = 5,
  WorkStarted = 6,
  WorkCompleted = 7,
  OwnerConfirmed = 8,
  ReviewReceived = 9,
}

export interface ProgressUpdate {
  id: string;
  offerId: string | null;
  serviceRequestId: string;
  authorCustomerId: string;
  authorName: string;
  updateType: UpdateType;
  message: string;
  createdDate: string;
}

// Phase 6C: Completion models
export interface ServiceCompletionDetails {
  id: string;
  offerId: string;
  serviceRequestId: string;
  completionSummary: string;
  actualLaborHours?: number;
  actualPartsCost?: number;
  finalCost?: number;
  providerNotes?: string;
  estimatedLaborHours?: number;
  estimatedPartsCost?: number;
  estimatedTotalCost: number;
  providerName: string;
  completedByProviderDate: string;
  confirmedByOwnerDate?: string;
  revisionRequestedDate?: string;
  revisionReason?: string;
  createdDate: string;
  canLeaveReview: boolean;
}

export interface MarkWorkCompleteFileDto {
  name: string;
  content: string; // base64
}

export interface MarkWorkCompleteRequest {
  completionSummary: string;
  actualLaborHours?: number;
  actualPartsCost?: number;
  finalCost?: number;
  providerNotes?: string;
  files?: MarkWorkCompleteFileDto[];
}

export interface RequestRevisionRequest {
  reason: string;
}

export interface ConfirmCompletionResponse {
  serviceRequestId: string;
  offerId: string;
  confirmedAt: string;
  canLeaveReview: boolean;
}

export interface ServiceExecutionState {
  progressUpdates: ProgressUpdate[];
  completion: ServiceCompletionDetails | null;
  completionLoading: boolean;
  loading: boolean;
  error: any;
}
